module.exports = __webpack_public_path__ + "static/media/US.8ced8f71.png";